import ApplicationAdapter from './application';

export default class SignInFieldAdapter extends ApplicationAdapter {
  pathForType() {
    return 'sign-in-fields';
  }
}
